import { createBrowserRouter, Navigate, type DataRouter } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireRole } from '@/components/auth/RequireRole';
import { BookingsPage } from '@/modules/bookings';
import { UsersPage } from '@/modules/users';
import ImpersonatePage from '@/pages/ImpersonatePage';
import NotFoundPage from '@/pages/NotFoundPage';
import { UserRole } from '@cargovibe/shared-types';

export const router: DataRouter = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/users" replace />,
      },
      {
        path: 'bookings',
        element: <BookingsPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'impersonateUser',
        element: (
          <RequireRole role={UserRole.Admin}>
            <ImpersonatePage />
          </RequireRole>
        ),
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
